import api from '../utils/api';

const certificatesService = {
  // Returns the raw fetch Response — caller does response.blob() and
  // triggers the download (see ReportCardPreviewModal.js pattern).
  generateCertificate: async (studentId, type, data) => {
    try {
      return await api.post(`/api/certificates/${studentId}/generate`, data || {}, { params: { type }, raw: true });
    } catch (error) {
      console.error('Error generating certificate:', error);
      throw error;
    }
  },
  listIssuances: async (params) => {
    try {
      return await api.get('/api/certificates/issuances', { params });
    } catch (error) {
      console.error('Error fetching certificate issuances:', error);
      throw error;
    }
  },
  reprintCertificate: async (issuanceId) => {
    try {
      return await api.get(`/api/certificates/issuances/${issuanceId}/reprint`, { raw: true });
    } catch (error) {
      console.error('Error reprinting certificate:', error);
      throw error;
    }
  },

  listTemplates: async (certificateType) => {
    try {
      return await api.get('/api/certificates/templates', { params: { certificate_type: certificateType } });
    } catch (error) {
      console.error('Error fetching certificate templates:', error);
      throw error;
    }
  },
  createTemplate: async (data) => {
    try {
      return await api.post('/api/certificates/templates', data);
    } catch (error) {
      console.error('Error creating certificate template:', error);
      throw error;
    }
  },
  updateTemplate: async (templateId, data) => {
    try {
      return await api.put(`/api/certificates/templates/${templateId}`, data);
    } catch (error) {
      console.error('Error updating certificate template:', error);
      throw error;
    }
  },
  deleteTemplate: async (templateId) => {
    try {
      return await api.delete(`/api/certificates/templates/${templateId}`);
    } catch (error) {
      console.error('Error deleting certificate template:', error);
      throw error;
    }
  },
  verify: async (certificateNumber) => {
    try {
      return await api.get(`/api/certificates/verify/${certificateNumber}`);
    } catch (error) {
      console.error('Error verifying certificate:', error);
      throw error;
    }
  },
};

export default certificatesService;
